export default __webpack_public_path__ + "static/media/person_1.1b490d2e.png";